

import { useEffect } from "react";
import "./instaFeed.css";

const InstagramFeed = () => {
  useEffect(() => {
    // Load the Elfsight script dynamically
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);

    // Function to find and remove Elfsight branding
    const removeElfsightBranding = () => {
      const brandingLinks = document.querySelectorAll('a[href*="elfsight.com"]');
      brandingLinks.forEach((link) => link.remove());
    };

    // Observe changes to the body and continuously remove branding
    const observer = new MutationObserver(removeElfsightBranding);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Also remove branding every 2 seconds as a fallback
    const interval = setInterval(removeElfsightBranding, 2000);

    return () => {
      observer.disconnect(); // Stop observer when component unmounts
      clearInterval(interval); // Clear interval
    };
  }, []);

  return (
    <div>
      {/* Elfsight Instagram Feed */}
      <div
        className="elfsight-app-16e0e2da-3d85-4967-a6d2-82f414d1c720"
        data-elfsight-app-lazy
      ></div>
    </div>
  );
};

export default InstagramFeed;
